import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useFieldValue } from 'Shared/utils/hooks';
import FormField from './FormField/FormField';

function ManualWorkspacesForm() {
  const workspaces = useFieldValue('workspaces');

  return (
    <div className="pr-4">
      <FieldArray name="workspaces">
        {({ fields }) =>
          fields.map((name, index) => {
            if (workspaces[index].recurring_meeting_uuid) return null;
            return (
              <FormField
                key={name}
                name={name}
                index={index}
                fieldsCount={2}
                remove={fields.remove}
                uuid={fields.value[index].uuid}
              />
            );
          })
        }
      </FieldArray>
    </div>
  );
}

export default ManualWorkspacesForm;
